import gql from 'graphql-tag'
export default gql`mutation unPublishRecipeMutation($recipeId: Int!) {
  unPublishRecipe(recipeId: $recipeId) {
    success
  }
}`